























import Vue from "vue";
import activiteType from "@/features/activites/components/activite-type.vue";

export default Vue.extend({
  data() {
    return {
      categotieActivite: {
        ACCUEIL_LOISIRS: this.$t(
          "anmobi.activite.categotieActivite.ACCUEIL_LOISIRS"
        ),
        ATELIER: this.$t("anmobi.activite.categotieActivite.ATELIER"),
        PERISCOLAIRE: this.$t("anmobi.activite.categotieActivite.PERISCOLAIRE"),
        RESTAURATION: this.$t("anmobi.activite.categotieActivite.RESTAURATION"),
        SECTEUR_JEUNES: this.$t(
          "anmobi.activite.categotieActivite.SECTEUR_JEUNES"
        ),
        SEJOUR: this.$t("anmobi.activite.categotieActivite.SEJOUR"),
        TACHES_ACCUEIL: this.$t(
          "anmobi.activite.categotieActivite.TACHES_ACCUEIL"
        ),
        GESTION_SCOLAIRE: this.$t(
          "anmobi.activite.categotieActivite.GESTION_SCOLAIRE"
        ),
        RAMASSAGE: this.$t("anmobi.activite.categotieActivite.RAMASSAGE"),
      } as any,
    };
  },
  props: {
    filtredActivites: {
      default: [],
    },
  },
  components: {
    activiteType,
  },
  methods: {
    getCategorieIntitule(cat: string) {
      return this.categotieActivite[cat];
    },
  },
});
